import { render, staticRenderFns } from "./PageTitleNavigation.vue?vue&type=template&id=01f93d52&"
import script from "./PageTitleNavigation.vue?vue&type=script&lang=js&"
export * from "./PageTitleNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports